import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import {
  faAngleLeft,
  faAngleRight,
  faAngleDown,
  faBell,
  faCheck,
  faCogs,
  faInfo,
  faPencilAlt,
  faPlusCircle,
  faSearch,
  faSpinner,
  faTrashAlt,
  faUser,
  faClone,
} from '@fortawesome/free-solid-svg-icons';

import { faClock } from '@fortawesome/free-regular-svg-icons';

import {
  faTimesCircle,
  faBan,
  faBars,
  faBuilding,
  faUndo,
  faCashRegister,
  faChartPie,
  faCheckCircle,
  faCheckDouble,
  faCog,
  faCompressArrowsAlt,
  faCreditCard,
  faCreditCardFront,
  faCrosshairs,
  faCube,
  faDesktop,
  faDollarSign,
  faDrawCircle,
  faEllipsisV,
  faExclamationTriangle,
  faFlask,
  faFlowerTulip,
  faGem,
  faGift,
  faGlobeAsia,
  faGlobe,
  faHeartRate,
  faHeart,
  faIceCream,
  faIndustry,
  faKey,
  faLeaf,
  faLightbulb,
  faMicrophone,
  faMicroscope,
  faPalette,
  faPaperPlane,
  faPaperclip,
  faPhone,
  faPodium,
  faPlus,
  faPuzzlePiece,
  faReceipt,
  faSackDollar,
  faSeedling,
  faShareAlt,
  faShieldAlt,
  faShoppingBag,
  faShoppingCart,
  faSitemap,
  faSuitcaseRolling,
  faTimes,
  faTire,
  faTrain,
  faTruck,
  faUsers,
  faUserFriends,
  faUserTie,
  faUsdCircle,
  faWallet,
  faWarehouseAlt,
  faExclamationCircle,
  faTv,
  faPlayCircle,
  faPlay,
  faStar,
  faLessThan,
  faUserHeadset,
} from '@fortawesome/pro-light-svg-icons';

library.add(
  // free-solid-svg-icons
  faSpinner,
  faTimesCircle,
  // free-solid-svg-icons
  faAngleLeft,
  faAngleRight,
  faAngleDown,
  faBell,
  faCheck,
  faCogs,
  faInfo,
  faPencilAlt,
  faPlusCircle,
  faSearch,
  faTrashAlt,
  faUser,
  faClone,
  faUndo,
  // free-regular-svg-icons
  faClock,

  // pro-light-svg-icons
  faBan,
  faBars,
  faBuilding,
  faCashRegister,
  faChartPie,
  faCheckCircle,
  faCheckDouble,
  faCog,
  faCompressArrowsAlt,
  faCreditCard,
  faCreditCardFront,
  faCrosshairs,
  faCube,
  faDesktop,
  faDollarSign,
  faDrawCircle,
  faEllipsisV,
  faExclamationTriangle,
  faFlask,
  faFlowerTulip,
  faGem,
  faGift,
  faGlobeAsia,
  faGlobe,
  faHeartRate,
  faHeart,
  faIceCream,
  faIndustry,
  faKey,
  faLeaf,
  faLightbulb,
  faMicrophone,
  faMicroscope,
  faPalette,
  faPaperPlane,
  faPaperclip,
  faPhone,
  faPodium,
  faPlus,
  faPuzzlePiece,
  faReceipt,
  faSackDollar,
  faSeedling,
  faShareAlt,
  faShieldAlt,
  faShoppingBag,
  faShoppingCart,
  faSitemap,
  faSuitcaseRolling,
  faTimes,
  faTire,
  faTrain,
  faTruck,
  faUsers,
  faUserFriends,
  faUserTie,
  faUsdCircle,
  faWallet,
  faWarehouseAlt,
  faExclamationCircle,
  faTv,
  faPlayCircle,
  faPlay,
  faStar,
  faLessThan,
  faUserHeadset,
);

Vue.component('font-awesome-icon', FontAwesomeIcon);
